import { memo, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormInput } from 'shards-react';
import { updateFilterByReference } from 'utils/redux/actions';

const FilterByReference = ({ dispatch, filterByReference = '' }) => {
  const [inputValue, setInputValue] = useState(() => filterByReference);

  const changeHandler = useCallback(
    ({ target }) => {
      const { value } = target;

      dispatch(updateFilterByReference(value));
      setInputValue(value);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(updateFilterByReference(inputValue));
    },
    [inputValue, dispatch]
  );

  return (
    <Form onSubmit={handleSubmit}>
      <FormInput
        required
        type="search"
        spellCheck="false"
        autoComplete="false"
        value={inputValue}
        onChange={changeHandler}
        placeholder="Nach Referenz filtern"
      />
    </Form>
  );
};

const mapStateToProps = ({ filterByReference }) => ({ filterByReference });

export default connect(mapStateToProps)(memo(FilterByReference));
